export const API_ROUTES = {
  SIGNUP: '/auth/signup',
  SIGNIN: '/auth/signin',
  TODO: 'todos',
};
